import { MenuService } from "./menu.services";
import { computed, inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class MenuDownloadService extends MenuService {
  private readonly menuService = inject(MenuService);
  //--------------------------------------------------------------------------------------------------------------------
  // Sauver exportation
  //--------------------------------------------------------------------------------------------------------------------
  yaml = computed<string>(() => {
    const lines: string[] = ["menu:"];

    for (const node of this.menuService.node()) {
      lines.push("  - archiveId: " + node.archiveId);
      lines.push("    parentId: " + this.toYamlValue(node.parentId));
      lines.push("    name: " + this.toYamlValue(node.name));
      lines.push("    nodeType: " + this.toYamlValue(node.nodeType));
      lines.push("    staffId: " + this.toYamlValue(node.staffId));
      lines.push("    label: " + this.toYamlValue(node.label));
      lines.push("    phone: " + this.toYamlValue(node.phone));
      lines.push("    email: " + this.toYamlValue(node.email));
      lines.push("    type: " + this.toYamlValue(node.type));
      lines.push(
        "    yearsExperience: " + this.toYamlValue(node.yearsExperience),
      );
      lines.push("    isPage: " + this.toYamlValue(node.isPage));
      lines.push(
        "    patientCapacity: " + this.toYamlValue(node.patientCapacity),
      );
      lines.push(
        "    selected: " + this.toYamlValue(node.isSelected),
      );
      lines.push("    certifications:");

      if (node.certifications.length === 0) {
        lines.push("      []");
      } else {
        for (const certification of node.certifications) {
          lines.push("      - " + this.toYamlValue(certification));
        }
      }

      lines.push("    hireDate: " + this.toYamlValue(node.hireDate));
    }

    return lines.join("\n");
  });

  private toYamlValue(value: string | number | boolean | Date | null): string {
    if (value === null) {
      return "null";
    }

    if (value instanceof Date) {
      return `"${value.toISOString()}"`;
    }

    if (typeof value === "string") {
      return JSON.stringify(value);
    }

    return String(value);
  }
}